// Components
import BannerImage from '../../atoms/BannerImage/BannerImage';

// Styles
import styles from './Banner.module.css';

/**
 * @function Banner
 * Describe the component's function
 *
 * @example
 * return (
 *   <Banner name="" image="" link="" text="" />
 * )
 */
function Banner({ name, image, link, text }: Banner): JSX.Element {
    return (
        <article className={styles.container}>
            <div className={styles.inner}>
                <header className={styles.header}>
                    <img
                        src={`https://${process.env.REACT_APP_CDN}/play-bingo/images/logos/logo-circle.svg`}
                        alt="logo"
                        className={styles.logo}
                    />
                    <hgroup className={styles.hgroup}>
                        <h3>Bingoport</h3>
                        <p>{name}</p>
                    </hgroup>
                </header>
                <div className={styles.content}>
                    <p
                        className={styles.text}
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                    {image !== '' && (
                        <BannerImage title={name} image={image} url={link} />
                    )}
                </div>
            </div>
        </article>
    );
}

/**
 * @interface Banner
 * Describes the properties required for the Banner component
 *
 * @property {string} name
 * @property {ReactNode} children
 */
export interface Banner {
    name: string;
    image: string;
    link: string;
    text: string;
}

// Exports
export default Banner;
